import BaseHooks from './base';

export default class extends BaseHooks {}
